<template>
  <div>
    <div class="text-xs-center my-4" v-if="loading">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <template v-else>
      <v-layout>
        <v-flex class="title primary--text my-2"><slot name="header"></slot></v-flex>
        <v-flex class="text-xs-right"
          ><v-btn depressed color="primary" @click="exportData">{{ $t('export') }}</v-btn></v-flex
        >
      </v-layout>
      <table class="table table-bordered table-hover mb-4" style="border: 1px solid #eee">
        <thead>
          <tr class="grey lighten-3">
            <td></td>
            <td class="text-xs-center">ขวดเล็ก (180 ml./190 g.)</td>
            <td class="text-xs-center">ขวดใหญ่ (250 ml./260 g.)</td>

            <td class="text-xs-center">รวม (ขวด)</td>
            <td class="text-xs-center">รวมปริมาตร (g.)</td>
          </tr>
        </thead>
        <tr v-if="data.length == 0">
          <td colspan="5" class="text-xs-center my-2">ไม่มีรายการสินค้า</td>
        </tr>
        <template v-else>
          <template v-for="(el, index) in data">
            <tr :key="index">
              <td>{{ el.name }}</td>
              <td class="text-xs-center">{{ el.small | numberFormat }}</td>
              <td class="text-xs-center">{{ el.big | numberFormat }}</td>
              <td class="text-xs-center">{{ (el.small + el.big) | numberFormat }}</td>
              <td class="text-xs-center">{{ (el.small * 190 + el.big * 260) | numberFormat }}</td>
            </tr>
          </template>
          <tr>
            <td>รวม</td>
            <td class="text-xs-center">{{ total.small | numberFormat }}</td>
            <td class="text-xs-center">{{ total.big | numberFormat }}</td>
            <td class="text-xs-center">{{ (total.small + total.big) | numberFormat }}</td>
            <td class="text-xs-center">
              {{ (total.small * 190 + total.big * 260) | numberFormat }}
            </td>
          </tr>
        </template>
      </table>
    </template>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { mapGetters } from 'vuex'

import api from '@/api'
export default {
  props: ['date', 'value', 'loading'],
  data() {
    return {
      data: {},
      datemodal: false,
      // loading: true,
      total: {
        small: 0,
        big: 0
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    this.data = this.value
    this.updateData()

    // this.loading = true
    // try {
    //   var response = await this.get_nvbb_product_amount_by_date()
    //   if (response.responsecode == 200) {
    //   }
    //   this.data = response.data

    // } catch (error) {
    //   console.log(error)
    // }
    // this.loading = false
  },
  methods: {
    exportData() {
      let data = []
      try {
        data = this.data.map((el) => {
          return {
            ชื่อ: el.name,
            'ขวดเล็ก (180 ml./190 g.)': el.small,
            'ขวดใหญ่ (250 ml./260 g.)': el.big,
            'รวม (ขวด)': el.small + el.big,
            'รวมปริมาตร (g.)': el.small * 190 + el.big * 260
          }
        })

        data.push({
          ชื่อ: 'รวม',
          'ขวดเล็ก (180 ml./190 g.)': this.total.small,
          'ขวดใหญ่ (250 ml./260 g.)': this.total.big,
          'รวม (ขวด)': this.total.small + this.total.big,
          'รวมปริมาตร (g.)': this.total.small * 190 + this.total.big * 260
        })

        // var json = this.value

        const dataWS = XLSX.utils.json_to_sheet(data)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, `summary-drink-phytomylk-${this.date}.xlsx`)
      } catch (error) {}
    },
    get_nvbb_product_amount_by_date() {
      var data = {
        pageid: this.selectedBot.pageid,
        tab: 'phytomylk',
        date: this.date
      }
      return new Promise((resolve, reject) => {
        api.get_nvbb_product_amount_by_date(data, (error, response) => {
          if (error) {
            reject(error)
          }
          if (response.data) {
            response.data = response.data.sort((a, b) => {
              return a.name.localeCompare(b.name)
            })
          }

          resolve(response)
        })
      })
    },
    updateData() {
      this.total = {
        small: 0,
        big: 0
      }
      if (this.data && this.data.length > 0) {
        this.total = this.data.reduce(
          (prev, curr) => {
            return {
              small: prev.small + curr.small,
              big: prev.big + curr.big
            }
          },
          {
            small: 0,
            big: 0
          }
        )
      }
    }
  },
  watch: {
    value(newVal) {
      this.data = newVal
      this.updateData()
    }
    // async date(newVal, oldVal) {
    //   if (newVal != oldVal) {
    //     this.loading = true
    //     try {
    //       var response = await this.get_nvbb_product_amount_by_date()
    //       if (response.responsecode == 200) {
    //       }
    //       this.data = response.data
    //       this.total = {
    //         small: 0,
    //         big: 0
    //       }
    //       if (this.data && this.data.length > 0) {
    //         this.total = this.data.reduce(
    //           (prev, curr) => {
    //             return {
    //               small: prev.small + curr.small,
    //               big: prev.big + curr.big
    //             }
    //           },
    //           {
    //             small: 0,
    //             big: 0
    //           }
    //         )
    //       }
    //     } catch (error) {
    //       console.log(error)
    //     }
    //     this.loading = false
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/NvbbSummaryDrinkPhytoMylkDetail.vue